import React from 'react';
import { Field } from 'react-form';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import PropTypes from 'prop-types';

import InfoButton from '../../InfoButton';
import { eventDivisionAgeSliderDictionary, getEventAgeDisplay } from '../../../utils/constants';

const EventDivisionAgeRangeSliderSmall = props => (
    <Field field={props.field} validate={props.validate}>

        { fieldApi => {
            const { onChange, onBlur, slideStop, field, validate, hoverText, ...rest } = props;
            const { value, setValue, setTouched } = fieldApi;

            const inputProps = {
                ...rest,
                value: value || [],
                change: e => {
                    setValue(e.target.value);
                    if (onChange) {
                        onChange(e.target.value, e);
                    }
                },
                onBlur: e => {
                    setTouched();
                    if (onBlur) {
                        onBlur(e);
                    }
                },
                slideStop: e => {
                    if (slideStop) {
                        slideStop(e, setValue);
                    }
                },
            };

            const ageDisplay = getEventAgeDisplay(value);

            return (
                <div className="form-group form-group-xl help slider-small slider-gray">
                    <label htmlFor="name" className="mb10">
                        Age
                        {hoverText && <InfoButton hoverText={hoverText} />}
                        <span className="utr text-dark">{ageDisplay}</span>
                    </label>
                    <div className="wrapper">
                        <ReactBootstrapSlider
                            {...inputProps}
                            startValue={[0, Object.keys(eventDivisionAgeSliderDictionary).length - 1]}
                            range={true}
                            min={0}
                            max={Object.keys(eventDivisionAgeSliderDictionary).length - 1}
                            step={1}
                        />
                    </div>
                </div>
            );
        }}
    </Field>
);

EventDivisionAgeRangeSliderSmall.propTypes = {
    field: PropTypes.string.isRequired,
    validate: PropTypes.func,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    hoverText: PropTypes.string,
    slideStop: PropTypes.func,
};

EventDivisionAgeRangeSliderSmall.defaultProps = {
    validate: () => {},
    onChange: () => {},
    onBlur: () => {},
    hoverText: '',
    slideStop: () => {},
};

export default EventDivisionAgeRangeSliderSmall;
